import { Link } from "react-router-dom";
import { ShieldCheck, Clock, MapPinned, ArrowRight } from "lucide-react";
/**
 * Compact trust band with a soft, faded background image behind the pillars.
 * Used on multiple pages — headline + 3 pillars + link to /cotizar.
 */
export default function TrustBand() {
  const points = [
    { icon: ShieldCheck, t: "Certificados", d: "Habilitados por el Ministerio de Transporte y con pólizas al día." },
    { icon: MapPinned, t: "Cobertura Nacional", d: "Desde Bogotá hacia los 32 departamentos de Colombia." },
    { icon: Clock, t: "Grupos desde 5 pax", d: "Van, buseta o bus según el tamaño y tipo de servicio." },
  ];
  return (
    <section data-testid="trust-band" className="py-20 md:py-24 relative border-t border-[#3A3229]/60 overflow-hidden isolate">
      <img
        src="/servicio-004.webp"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-25 -z-10"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,9,8,0.85) 0%, rgba(10,9,8,0.7) 45%, rgba(10,9,8,0.9) 100%)",
        }}
      />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid md:grid-cols-3 gap-5 mb-10">
          {points.map((p) => {
            const I = p.icon;
            return (
              <div key={p.t} className="flex gap-4 items-start p-5 card-lux backdrop-blur-md bg-[#0A0908]/60">
                <div className="w-11 h-11 shrink-0 rounded-lg bg-[#D4AF37]/12 border border-[#D4AF37]/30 flex items-center justify-center">
                  <I size={20} className="text-[#E8C87A]" />
                </div>
                <div>
                  <div className="font-display text-xl text-[#F5EFE0]">{p.t}</div>
                  <div className="text-sm text-[#F5EFE0]/70 mt-1">{p.d}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="text-center">
          <Link to="/cotizar" data-testid="trust-cta" className="btn-gold inline-flex items-center gap-2 px-7 py-3 rounded-full text-sm">
            Cotizar mi servicio <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
